import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Grid, Typography, withStyles } from '@material-ui/core';

const styles = theme => ({
    strip: {
        width: '100%',
        maxWidth: 1200,
        minHeight: 92,
        margin: '0 auto',
        marginBottom: theme.spacing(2.5),
        padding: theme.spacing(1, 2.25),
        borderRadius: 12,
        background: 'linear-gradient(120deg, rgba(37, 38, 52, 0.9), rgba(52, 44, 73, 0.86))',
        border: '1px solid rgba(255, 255, 255, 0.12)',
        boxShadow: '0 8px 16px rgba(0,0,0,0.24)',
        display: 'flex',
        alignItems: 'center',
        '@media (max-width: 768px)': {
            marginBottom: 0,
        },
    },
    columns: {
        margin: 0,
        width: '100%',
        alignItems: 'center',
    },
    columnLeft: {
        textAlign: 'left',
    },
    columnCenter: {
        textAlign: 'center',
        borderLeft: '1px solid rgba(255, 255, 255, 0.14)',
        borderRight: '1px solid rgba(255, 255, 255, 0.14)',
        padding: theme.spacing(0, 2),
    },
    columnRight: {
        textAlign: 'right',
        lineHeight: 1.35,
    },
    teamTitle: {
        color: '#fff',
        fontWeight: 800,
        letterSpacing: 1.2,
        textTransform: 'uppercase',
        lineHeight: 1.1,
        fontSize: 18,
    },
    password: {
        color: 'rgba(255, 255, 255, 0.78)',
        fontWeight: 600,
        fontSize: 13,
        marginTop: theme.spacing(0.25),
    },
    answerLabel: {
        color: 'rgba(255, 255, 255, 0.72)',
        textTransform: 'uppercase',
        fontWeight: 700,
        fontSize: 11,
        letterSpacing: 1,
        lineHeight: 1,
    },
    answerNumber: {
        color: '#fff',
        fontWeight: 800,
        fontSize: 23,
        letterSpacing: 0.35,
        lineHeight: 1.15,
        marginTop: theme.spacing(0.45),
    },
    detailLine: {
        color: 'rgba(255, 255, 255, 0.85)',
        fontWeight: 500,
        fontSize: 12,
        '& + &': {
            marginTop: theme.spacing(0.35),
        },
    },
});

function TeamCallInStrip({ classes }) {
    const [callInInfo, setCallInInfo] = useState(null);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        let isActive = true;

        axios.get('/api/team-callin')
            .then((response) => {
                if (!isActive) {
                    return;
                }

                setCallInInfo(response.data || null);
                setLoaded(true);
            })
            .catch((error) => {
                if (!isActive) {
                    return;
                }

                if (error && error.response && (error.response.status === 403 || error.response.status === 404)) {
                    setCallInInfo(null);
                    setLoaded(true);
                    return;
                }

                console.error('Failed to load Team Call-In info.');
                setCallInInfo(null);
                setLoaded(true);
            });

        return () => {
            isActive = false;
        };
    }, []);

    if (!loaded || !callInInfo) {
        return null;
    }

    return (
        <Box className={classes.strip}>
            <Grid container spacing={2} className={classes.columns}>
                <Grid item md={3} className={classes.columnLeft}>
                    <Typography component="p" className={classes.teamTitle}>{callInInfo.teamLabel || ''}</Typography>
                    <Typography component="p" className={classes.password}>{`Password – ${callInInfo.password || ''}`}</Typography>
                </Grid>
                <Grid item md={5} className={classes.columnCenter}>
                    <Typography component="p" className={classes.answerLabel}>Answer Line</Typography>
                    <Typography component="p" className={classes.answerNumber}>{callInInfo.answerLine || ''}</Typography>
                </Grid>
                <Grid item md={4} className={classes.columnRight}>
                    <Typography component="p" className={classes.detailLine}>{`${callInInfo.infoRepeat || ''}`}</Typography>
                    <Typography component="p" className={classes.detailLine}>{`${callInInfo.pointDispute || ''}`}</Typography>
                    <Typography component="p" className={classes.detailLine}>{`${callInInfo.questionDispute || ''}`}</Typography>
                </Grid>
            </Grid>
        </Box>
    );
}

export default withStyles(styles)(TeamCallInStrip);
